<template>
  <div>
    <div class="r-text-headline-paragraph">היי {{firstName}}!</div>
    <div class="r-form">
      <div class="r-form-row">
        <default-text-input
          :value="phoneNumber"
          type="tel"
          label="מספר טלפון נייד"
          autofocus
          validations="required|digits:10"
          @input="setPhoneNumber"
          @observe="observe" />
      </div>

      <div class="r-form-row">
        <default-text-input
          :value="email"
          type="email"
          label="כתובת מייל"
          autocomplete="email"
          validations="required|email"
          @input="setEmail"
          @observe="observe"/>
      </div>

      <div class="r-form-row">
        <default-checkbox :value="enableMarketingEmails" @input="setEnableMarketingEmails">
          <div>אשמח לקבל עדכונים, טיפים וחדשות למייל</div>
        </default-checkbox>
      </div>

    </div>
    <default-button label='שלחו לי קוד אימות' @click="generateCodeAndProceed" :loading="loading"/>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import TrackedPage from '@/mixins/TrackedPage';
import ValidationObserver from '@/mixins/ValidationObserver';
import DefaultButton from '@/components/styled/DefaultButton';
import DefaultTextInput from '@/components/styled/DefaultTextInput';
import DefaultCheckbox from '@/components/styled/DefaultCheckbox';
import Intercom from '@/Intercom';
import * as LoginApi from '@/api/LoginApi';

export default {
  name: 'SignupContactDetails',
  mixins: [TrackedPage, ValidationObserver],
  components: { DefaultCheckbox, DefaultTextInput, DefaultButton },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState('signup', ['email', 'firstName', 'enableMarketingEmails']),
    ...mapState('authentication', ['phoneNumber']),
  },
  methods: {
    ...mapMutations('signup', ['setEmail', 'setEnableMarketingEmails']),
    ...mapMutations('authentication', ['setPhoneNumber']),
    async generateCodeAndProceed() {
      await Intercom.boot(null, { email: this.email, phone: this.phoneNumber, name: this.firstName });
      this.loading = true;
      try {
        const { valid } = await this.validate();
        if (valid) {
          await LoginApi.generateCode({ phoneNumber: this.phoneNumber, force: false });
          await this.$router.push({ path: 'enter-otp' });
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
